import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToAnchor = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Standard scroll to top on route change
    if (!hash) {
      window.scrollTo(0, 0);
    } else {
      // If there is a hash, wait for render then scroll
      const id = hash.replace('#', '');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      }, 100); // Slight delay to ensure DOM is ready
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToAnchor;